<template>
  <v-container>
    <v-container class="ma-0 pa-0 d-flex">
      <h1>База мастеров</h1>
    </v-container>

    <v-container class="ma-0 pa-0 mt-2">
      <v-data-table
        :headers="tblHeaders"
        :items="items"
        item-key="_id"
        class="elevation-1"
        :loading="loadingSpecialists"
        loading-text="Данные загружаются... Пожалуйста, подождите."
        :search="search"
        show-expand
      >
        <template v-slot:top>
          <div>
            <v-text-field
              v-model="search"
              placeholder="Поиск по городу, имени, номеру телефона, специализации"
              class="pl-4 pr-4"
              clearable
            ></v-text-field>
          </div>
        </template>
        <template v-slot:[`item.actions`]="{item}">
          <delete-button
            v-if="isAdmin"
            :id="item._id"
            objName="анкету"
            :deleteFunc="$store.dispatch"
            funcParam="users/deleteSpecialist"
          >
            Имя: {{ item.name }} <br>
          </delete-button>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="pa-2">
            <p v-if="item.email"><strong>Email:</strong> {{ item.email }}</p>
            <p v-if="item.ageYears"><strong>Возраст (лет):</strong> {{ item.ageYears }}</p>
            <p v-if="item.experienceYears"><strong>Опыт в отделке (лет):</strong> {{ item.experienceYears }}</p>
            <p v-if="item.about">
              <strong>О себе: </strong> {{ item.about }}
            </p>
          </td>
        </template>
      </v-data-table>
    </v-container>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  data() {
    return {
      search: '',
      tblHeaders: [
        {
          text: 'Город',
          value: 'site.city.name'
        },
        {
          text: 'Имя',
          value: 'name'
        },
        {
          text: 'Телефон',
          value: 'phoneNumber'
        },
        {
          text: 'Специализации',
          value: 'specs'
        },
        {
          text: 'Доп.инфо',
          value: 'data-table-expand'
        },
        {
          text: '',
          value: 'actions'
        },
      ]
    }
  },

  created() {
    this.$store.dispatch('users/loadSpecialists');
  },

  computed: {
    ...mapState('users', ['specialists']),
    ...mapGetters('users', ['loadingSpecialists', 'isAdmin']),
    items() {
      return this.specialists.map(x => ({
        ...x,
        specs: x.specializations.join('; ')
      }));
    }
  }
}
</script>